const COLLATOR = new Intl.Collator(undefined, { numeric: true });
// Helper function to compare strings numerically if possible
const compareString = (a, b) => COLLATOR.compare(a, b);
export const DEFAULT_ITEM_COMPARATOR = (a, b) => {
    var _a, _b;
    const valA = (a.name || "").toLowerCase();
    const valB = (b.name || "").toLowerCase();
    let result = compareString(valA, valB);
    if (result === 0) {
        // Try to use the id to stable sort identical item names
        const aId = (_a = a.id) === null || _a === void 0 ? void 0 : _a.toString();
        const bId = (_b = b.id) === null || _b === void 0 ? void 0 : _b.toString();
        if (aId && bId) {
            result = compareString(aId, bId);
        }
    }
    return result;
};
/**
 * Determines if a Unicode value is a number
 */
const isUnicodeDigit = (c) => c >= 48 && c <= 57;
/**
 * Finds the index of the end of a number in a string
 */
const findIndexOfEndDigit = (str, startDigitIndex) => {
    let i = startDigitIndex + 1;
    for (i; i < str.length; i += 1) {
        if (!isUnicodeDigit(str.charCodeAt(i))) {
            return i;
        }
    }
    return i;
};
const naturalOrderCompare = (a, b) => {
    let i = 0;
    for (i; i < a.length; i += 1) {
        const charA = a.charCodeAt(i);
        const charB = b.charCodeAt(i);
        if (!charB)
            return 1;
        if (isUnicodeDigit(charA) && isUnicodeDigit(charB)) {
            const aEndIndex = findIndexOfEndDigit(a, i);
            const bEndIndex = findIndexOfEndDigit(b, i);
            if (aEndIndex > bEndIndex)
                return 1;
            if (aEndIndex < bEndIndex)
                return -1;
            // Same number of digits, compare them
            for (let j = i; j < aEndIndex; j += 1) {
                const nextCharA = a.charCodeAt(j);
                const nextCharB = b.charCodeAt(j);
                if (nextCharA > nextCharB)
                    return 1;
                if (nextCharA < nextCharB)
                    return -1;
            }
            // Same number, update the number of compared chars
            i = aEndIndex - 1;
        }
        else {
            // Compare alphabetic chars.
            if (charA > charB)
                return 1;
            if (charA < charB)
                return -1;
        }
    }
    // b is equal up to the length of a, check if b still contains more characters
    return b.charCodeAt(i) ? -1 : 0;
};
export const FAST_ITEM_COMPARATOR = (a, b) => {
    const nameA = (a.name || "").toLowerCase();
    const nameB = (b.name || "").toLowerCase();
    const result = naturalOrderCompare(nameA, nameB);
    if (result !== 0) {
        return result;
    }
    // Names are equal, stable sort by comparing the id as well
    const idA = a.id || "";
    const idB = b.id || "";
    if (!idA || !idB)
        return 0;
    if (idA.length > idB.length)
        return 1;
    if (idA.length < idB.length)
        return -1;
    let i = 0;
    for (i; i < idA.length; i += 1) {
        const charA = idA.charCodeAt(i);
        const charB = idB.charCodeAt(i);
        if (charA > charB || !charB)
            return 1;
        if (charA < charB)
            return -1;
    }
    // b's id is equal up to the length of a's id, check if b's id still contains more characters
    return idB.charCodeAt(i) ? -1 : 0;
};
/**
 * A fast comparator that will only compare names as strings. Not stable, not alphanumeric.
 * Can be used before another comparator to get the order "mostly" right to simplify
 * the next round of sorting.
 */
export const SIMPLE_ITEM_COMPARATOR = (a, b) => {
    var _a, _b;
    const valA = (_a = a.name) !== null && _a !== void 0 ? _a : "";
    const valB = (_b = b.name) !== null && _b !== void 0 ? _b : "";
    if (valA > valB)
        return 1;
    if (valA < valB)
        return -1;
    return 0;
};
// https://www.typescriptlang.org/docs/handbook/2/narrowing.html
export function isFilterGroup(item) {
    return item.items !== undefined;
}
export const getFilterItemKey = (filterItem, groupId) => `${groupId || ""}|${filterItem.id || filterItem.name}`;
const countItems = (total, item) => {
    if (isFilterGroup(item)) {
        return item.items.reduce(countItems, total);
    }
    return total + 1;
};
export const getFilterItemCount = (results) => results.items.reduce(countItems, 0);
